import request from '@/utils/request'

// 分页查询子系统管理列表
export function paginationSystem(query = {}, pagination) {
  return request({
    url: `/system/system/pagination?pageNum=${pagination.pageNum}&pageSize=${pagination.pageSize}`,
    method: 'post',
    data: query
  })
}

// 不分页查询子系统管理列表
export function listSystem(query = {}) {
  return request({
    url: '/system/system/list',
    method: 'post',
    data: query
  })
}

// 查询子系统管理详细
export function getSystem(systemId) {
  return request({
    url: '/system/system/info/' + systemId,
    method: 'get'
  })
}

// 新增子系统管理
export function addSystem(data) {
  return request({
    url: '/system/system/add',
    method: 'post',
    data: data
  })
}

// 修改子系统管理
export function updateSystem(data) {
  return request({
    url: '/system/system/edit',
    method: 'put',
    data: data
  })
}

// 删除子系统管理
export function delSystem(systemId) {
  return request({
    url: '/system/system/remove/' + systemId,
    method: 'delete'
  })
}
